"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = [{
  key: 'validateOn',
  ignore: true
}, {
  key: 'unique',
  ignore: true
}];
exports.default = _default;